import React from 'react';
import './terms.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: December 2023</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Information We Collect</h2>
            <p>
              At Ernestic Fashion, we collect information that you provide directly to us, 
              including when you create an account, make a purchase, or contact our customer service.
            </p>
            <ul>
              <li><strong>Personal Information:</strong> Name, email address, phone number, shipping address</li>
              <li><strong>Payment Information:</strong> Credit card details, billing address (processed securely through our payment partners)</li>
              <li><strong>Preferences:</strong> Size preferences, style interests, customization requests</li>
              <li><strong>Technical Data:</strong> IP address, browser type, device information</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Process and fulfill your orders for bespoke fashion items</li>
              <li>Provide personalized tailoring and design services</li>
              <li>Communicate with you about orders, products, and promotions</li>
              <li>Improve our services and customer experience</li>
              <li>Ensure the security of your account and transactions</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Information Sharing</h2>
            <p>
              We do not sell your personal information to third parties. We may share your information with:
            </p>
            <ul>
              <li><strong>Service Providers:</strong> Payment processors, shipping carriers, IT services</li>
              <li><strong>Professional Tailors:</strong> To fulfill your custom clothing requests</li>
              <li><strong>Legal Authorities:</strong> When required by law or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In connection with mergers or acquisitions</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Data Security</h2>
            <p>
              We implement industry-standard security measures to protect your personal information. 
              This includes encryption, secure servers, and regular security assessments. However, 
              no method of transmission over the Internet is 100% secure.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access and review your personal information</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
              <li>Data portability</li>
            </ul>
            <p>To exercise these rights, contact us at privacy@ernesticfashion.com</p>
          </section>

          <section className="legal-section">
            <h2>6. International Transfers</h2>
            <p>
              As a global fashion brand, your data may be transferred to and processed in countries 
              outside of your residence. We ensure appropriate safeguards are in place for such transfers.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please contact our Data Protection Officer:
            </p>
            <div className="contact-info">
              <p>Email: privacy@ernesticfashion.com</p>
              <p>Phone: +1 (555) 123-ERNESTIC</p>
              <p>Address: 456 Fashion Avenue, Design District</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;